import { createSlice } from "@reduxjs/toolkit";
import {
  getReceivers,
  getReceiversGetFilters,
  getReceiversGetFiltersExport,
  addNewReceiver,
  addNewReceiverClient,
  updateReceiver,
  deleteReceiver,
} from "./thunk";

export const initialState = {
  receivers: [],
  receiversGetFilters: [],
  receiversGetFiltersExport: [],
  error: {},
  isLoading: false,
  isReceiversSuccess: false,
  isReceiversFailed: false,
  isReceiversGetFiltersSuccess: false,
  isReceiversGetFiltersFailed: false,
  isLoadingGetFilters: false,
  isReceiversGetFiltersExportSuccess: false,
  isReceiversGetFiltersExporFailed: false,
  isLoadingGetFiltersExport: false,
};

const receiversSlice = createSlice({
  name: "receiver",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getReceivers.fulfilled, (state, action) => {
      state.receivers = action.payload;
      state.isReceiversFailed = false;
      state.isReceiversSuccess = true;
    });

    builder.addCase(getReceivers.rejected, (state, action) => {
      state.error = action.payload || "Failed to fetch receivers";
      state.isReceiversFailed = true;
      state.isReceiversSuccess = false;
    });

    builder
      .addCase(getReceiversGetFilters.pending, (state) => {
        state.isLoadingGetFilters = true;
        state.isReceiversGetFiltersFailed = false;
        state.isReceiversGetFiltersSuccess = false;
      })

      .addCase(getReceiversGetFilters.fulfilled, (state, action) => {
        const {
          containers = [],
          totalStatusCounts = {},
          totalCount = 0,
          countsPerDate = {},
          overdueCount = 0,
          totalFee = 0,
          totalWeight = 0,
          totalQty = 0,
        } = action.payload || {};

        state.receiversGetFilters = containers;
        state.totalStatusCounts = totalStatusCounts;
        state.totalCount = totalCount;
        state.countsPerDate = countsPerDate;
        state.overdueCount = overdueCount;
        state.totalFee = totalFee;
        state.totalWeight = totalWeight;
        state.totalQty = totalQty;

        state.isLoadingGetFilters = false;
        state.isReceiversGetFiltersFailed = false;
        state.isReceiversGetFiltersSuccess = true;
      })

      .addCase(getReceiversGetFilters.rejected, (state, action) => {
        state.error =
          action.payload?.error ||
          action.error?.message ||
          "An unknown error occurred.";
        state.isLoadingGetFilters = false;
        state.isReceiversGetFiltersFailed = true;
        state.isReceiversGetFiltersSuccess = false;
      });

    builder
      .addCase(getReceiversGetFiltersExport.pending, (state) => {
        state.isLoadingGetFiltersExport = true;
        state.isReceiversGetFiltersExportFailed = false;
        state.isReceiversGetFiltersExportSuccess = false;
      })

      .addCase(getReceiversGetFiltersExport.fulfilled, (state, action) => {
        const { containers = [], totalCount = 0 } = action.payload || {};

        state.receiversGetFiltersExport = containers;
        state.totalCount = totalCount;

        state.isLoadingGetFiltersExport = false;
        state.isReceiversGetFiltersExportFailed = false;
        state.isReceiversGetFiltersExportSuccess = true;
      })

      .addCase(getReceiversGetFiltersExport.rejected, (state, action) => {
        state.error =
          action.payload?.error ||
          action.error?.message ||
          "An unknown error occurred.";
        state.isLoadingGetFiltersExport = false;
        state.isReceiversGetFiltersExportFailed = true;
        state.isReceiversGetFiltersExportSuccess = false;
      });

    builder.addCase(addNewReceiver.fulfilled, (state, action) => {
      state.receivers.push(action.payload);
      state.isReceiverAdd = true;
      state.isReceiverAddFail = false;
    });

    builder.addCase(addNewReceiver.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isReceiverAdd = false;
      state.isReceiverAddFail = true;
    });

    builder.addCase(addNewReceiverClient.fulfilled, (state, action) => {
      state.receivers.push(action.payload);
      state.isReceiverAdd = true;
      state.isReceiverAddFail = false;
    });

    builder.addCase(addNewReceiverClient.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isReceiverAdd = false;
      state.isReceiverAddFail = true;
    });

    builder.addCase(updateReceiver.fulfilled, (state, action) => {
      state.receivers = state.receivers.map((receiver) =>
        receiver._id.toString() === action.payload._id.toString()
          ? { ...receiver, ...action.payload }
          : receiver
      );
      state.isReceiverUpdate = true;
      state.isReceiverUpdateFail = false;
    });

    builder.addCase(updateReceiver.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isReceiverUpdate = false;
      state.isReceiverUpdateFail = true;
    });

    builder.addCase(deleteReceiver.fulfilled, (state, action) => {
      state.receivers = (state.receivers || []).filter(
        (receiver) =>
          receiver._id.toString() !== action.payload.receiver.toString()
      );
      state.isReceiverDelete = true;
      state.isReceiverDeleteFail = false;
    });

    builder.addCase(deleteReceiver.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isReceiverDelete = false;
      state.isReceiverDeleteFail = true;
    });
  },
});

export default receiversSlice.reducer;
